import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Constants } from '../lib/const/constants';
import Beneficiary from './Beneficiaries/Beneficiary';
import SkeletonTable from '../components/ui/SkeletonTable';
import axios from 'axios';

function ListBeneficiaries() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [searchName, setsearchName] = useState('');

  const getData = async () => {
    const login_id = sessionStorage.getItem('login_id');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const login_token = sessionStorage.getItem('login_token');
    if (!login_id || !login_token) {
      if (staff_login_id === '' || staff_login_id == null) {
        sessionStorage.clear();
        navigate('/business');
      } else {
        navigate('/DebitTransactions');
      }
    }
  };

  useEffect(() => {
    getData(0);
    setLoading(true);
    beneficiaryList();
  }, [searchName]);

  const beneficiaryList = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('login_token');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');
    getBene(token, workspaceId);
  };

  const getBene = async (token, workspaceId) => {
    setLoading(true);
    const countries = JSON.parse(sessionStorage.getItem('countries')) || [];
    let beneficiaryLists = [];
    await axios
      .get(
        `${Constants.BASE_URL}API-FX-211-LIST-ALL-BENEFICIARIES?workspace_id=${workspaceId}&name=${searchName}`,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        },
      )
      .then((resp) => {
        var beneData = resp.data.data;
        console.log('bbbbb', beneData);
        beneData.forEach((element) => {
          const normalizedType =
            element.type &&
            ['business', 'corporate', 'company'].includes(
              element.type.toLowerCase(),
            )
              ? 'Business'
              : 'Individual';
          if (element.provider === 'clear_bank') {
            beneficiaryLists.push({
              id: element.id,
              display_name: element.beneficiaryName,
              bank_account_number: element.banks[0].accountNumber,
              country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
              avatar: '',
              code: element.banks[0].sortCode,
              bank_code_type: 'sort_code',
              type: normalizedType,
              country: element.country,
              bank_account_name: '',
              bank_account_id: element.banks[0].id,
              currency: 'GBP',
              country_id: 231,
              bene_type: element.type,
              bank_type: element.provider,
            });
          } else {
            beneficiaryLists.push({
              id: element.id,
              display_name: element.display_name,
              bank_account_number:
                element.meta.bank_account_number || element.meta.iban,
              country_flag: '',
              avatar: '',
              code:
                element.meta.bic_number ??
                element.meta.aba_number ??
                element.meta.ifsc_code ??
                element.meta.sort_code ??
                element.meta.branch_code ??
                element.meta.bsb_number ??
                element.meta.routing_code_value_1,
              bank_code_type: element.meta.bank_code_type,
              type: normalizedType,
              country:
                countries.find(
                  (country) =>
                    Number(country.id) ===
                    Number(element.meta.selected_bank_country),
                )?.name || '',
              address:element.meta.beneficiary_address,
              bank_account_name: element.meta.bank_account_name,
              bank_account_id: '',
              currency: '',
              country_id: element.meta.bank_country,
              bene_type: element.type,
              bank_type: element.provider,
              meta: element.meta,
            });
          }
        });
        setBeneficiaries(beneficiaryLists);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
      });
  };

  const selectedBeneficiary = (
    display_name,
    code,
    bank_account_number,
    type,
    beneficiaryid,
    country,
    address,
    bank_account_id,
    country_id,
    bene_type,
    bank_type,
    currency,
    payment_type,
    meta
  ) => {
    console.log(currency);
    console.log(address);

    if (
      country_id &&
      bene_type != '' &&
      bene_type != null &&
      bank_type != '' &&
      bank_type != null
    ) {
      navigate('/SendMoneyByBeneficiary', {
        state: {
          currencyid: country_id,
          currency,
          selectedBeneficiary: display_name.toUpperCase(),
          selectedbeneficiaryCode: code,
          selectedbeneficiaryBankAccoutNumber: bank_account_number,
          selectedbeneficiaryType: type,
          selectedbeneficiaryId: beneficiaryid,
          selectedbeneficiaryCountry: country,
          selectedbeneficiaryBankAccountId: bank_account_id,
          selectedbene_type: bene_type,
          selectedbank_type: bank_type,
          selectedbeneficiaryAddress: address,
          selectedbeneficiaryPaymentType: payment_type, 
          selectedbeneficiaryMeta: meta,
        },
      });
    }
  };

  return (
    <div
      className="my-2 px-8 pt-6"
      style={{
        background: `
          #ffffff linear-gradient(
            180deg,
            rgba(248, 250, 252, 1) 0%,
            rgba(239, 246, 255, 0.3) 50%,
            rgba(238, 242, 255, 0.4) 100%
          )
        `,
      }}
    >
      {/* Centered heading */}
      <h2 className="text-[24px] font-bold text-center mb-6 text-[#394784] leading-[100%]">
        Beneficiary List
      </h2>

      <div
        style={{
          background: '#FFFFFF',
          borderRadius: '16px',
          borderBottom: '1px solid #F3F2F2',
          overflow: 'hidden',
          boxShadow: '0px 4px 16px -4px rgba(0,0,0,0.06)',
          paddingTop: '24px',
          paddingBottom: '24px',
          // height: '747.79px',
          width: '960px',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 16,
            marginBottom: 16,
            paddingLeft: '24px',
            paddingRight: '24px',
          }}
        >
          {/* Search */}
          <div
            style={{
              position: 'relative',
              width: '340px',
              height: '44px',
              flexShrink: 0,
            }}
          >
            {/* Icon */}
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              style={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            >
              <circle cx="11" cy="11" r="7" stroke="#667085" strokeWidth="2" />
              <path
                d="M16.5 16.5L21 21"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <input
              type="text"
              pattern=".{3,}"
              value={searchName}
              title="3 characters minimum"
              placeholder="Search Beneficiary"
              onChange={(e) => setsearchName(e.target.value)}
              style={{
                width: '100%',
                height: '44px',
                borderRadius: '8px',
                border: '1px solid #E8E8E8',
                background: '#FDFDFD',
                padding: '12px 16px 12px 40px',
                color: '#101828',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: 'Inter, sans-serif',
              }}
            />
          </div>

          {/* Button */}
          <button
            onClick={() =>
              navigate('/SelectCurrencyForBeneficiary', {
                state: { node: 1 },
              })
            }
            style={{
              height: '44px',
              background: '#D26521',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontWeight: 700,
              fontSize: '14px',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexShrink: 0,
              fontFamily: 'Inter, sans-serif',
              boxShadow: '0px 8px 20px rgba(0,0,0,0.12)',
            }}
          >
            <span style={{ fontSize: '18px', lineHeight: 1 }}>+</span>
            Add Beneficiary
          </button>
        </div>

        {/* Beneficiary list */}
        {loading ? (
          <SkeletonTable />
        ) : (
          <Beneficiary
            beneficiaryList={beneficiaries}
            sendDataToParent={selectedBeneficiary}
            pay={true}
          />
        )}
      </div>
    </div>
  );
}

export default ListBeneficiaries;
